/** Returns "1 trip" / "2 trips". Pass `pluralForm` for irregular plurals (e.g. "entry" -> "entries"). */
export function plural(count: number, singular: string, pluralForm?: string): string {
  return `${count} ${count === 1 ? singular : (pluralForm ?? `${singular}s`)}`;
}
